export const getShortText = (text?: string, maxLength: number = 100) => {
  if (!text) return "";
  if (text.length < maxLength) return text;
  return text.slice(0, maxLength - 3) + "...";
};

export function displayStoreId(storeId: string | number) {
  return storeId.toString().slice(-8);
}
